import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import { forwardRef } from "react";
export const cardAction = tailwindVariants({
    base: "pointer-events-auto flex h-6 min-w-[24px] items-center justify-center gap-1 rounded px-1",
    variants: {
        color: {
            light: "bg-pigeon-100 text-pigeon-700 hover:bg-pigeon-200 hover:text-pigeon-700 focus-visible:bg-pigeon-200 focus-visible:text-pigeon-700 active:bg-pigeon-200 active:text-pigeon-700",
            dark: "bg-black/70 text-white hover:bg-black hover:text-white focus-visible:bg-black focus-visible:text-white active:bg-black active:text-white"
        }
    },
    defaultVariants: {
        color: "dark"
    }
});
export const CardAction = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { icon, text, color, className, ...rest } = param;
    return /*#__PURE__*/ _jsxs("button", {
        ...rest,
        ref: ref,
        className: cardAction({
            color,
            class: className
        }),
        children: [
            icon,
            !!text && /*#__PURE__*/ _jsx("span", {
                className: "text-12 uppercase text-inherit",
                children: text
            })
        ]
    });
});
CardAction.displayName = "CardAction  ";
